import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, Phone, Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import CartSheet from "./CartSheet";

const Navigation = () => {
  const { itemCount } = useCart();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  return (
    <nav data-testid="navigation" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-white'}`}>
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="logo">
            <img 
              src="/images/logo_transparent.png" 
              alt="KOSS LAB" 
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <Link to="/catalog" className="text-[#475569] hover:text-[#0f172a] font-medium transition-colors">Каталог</Link>
            <Link to="/about" className="text-[#475569] hover:text-[#0f172a] font-medium transition-colors">Эксперт</Link>
            <Link to="/publications" className="text-[#475569] hover:text-[#0f172a] font-medium transition-colors">Публикации</Link>
            <Link to="/b2b" className="text-[#475569] hover:text-[#0f172a] font-medium transition-colors">Для специалистов</Link>
            <Link to="/contact" className="text-[#475569] hover:text-[#0f172a] font-medium transition-colors">Контакты</Link>
          </div>

          <div className="flex items-center gap-4">
            <a href="tel:+79265995252" className="hidden md:flex items-center gap-2 text-[#0f172a] font-medium text-sm">
              <Phone className="w-4 h-4 text-[#14b8a6]" />
              <span>+7 (926) 599-52-52</span>
            </a>

            <Sheet>
              <SheetTrigger asChild>
                <button className="relative p-2.5 rounded-xl bg-[#f8fafc] hover:bg-[#f1f5f9] transition-colors" data-testid="cart-button">
                  <ShoppingCart className="w-5 h-5 text-[#0f172a]" />
                  {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
                </button>
              </SheetTrigger>
              <SheetContent className="w-full sm:max-w-lg"><CartSheet /></SheetContent>
            </Sheet>

            <button className="lg:hidden p-2.5 rounded-xl bg-[#f8fafc] hover:bg-[#f1f5f9] transition-colors" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-btn">
              {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="lg:hidden py-6 border-t border-[#f1f5f9] animate-fade-in">
            <div className="flex flex-col gap-4">
              <Link to="/catalog" className="text-[#475569] hover:text-[#0f172a] font-medium py-2">Каталог</Link>
              <Link to="/about" className="text-[#475569] hover:text-[#0f172a] font-medium py-2">Эксперт</Link>
              <Link to="/publications" className="text-[#475569] hover:text-[#0f172a] font-medium py-2">Публикации</Link>
              <Link to="/b2b" className="text-[#475569] hover:text-[#0f172a] font-medium py-2">Для специалистов</Link>
              <Link to="/contact" className="text-[#475569] hover:text-[#0f172a] font-medium py-2">Контакты</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
